import { isNil } from "@hopper-ui/components";
import { MixpanelEventName, MixpanelProperty } from "@sg-protect/shell";
import type { DOMEventTelemetryHandler } from "./domEventTracker.ts";
import { getClosestRole, getModalInformation, getTelemetryName } from "./utils.ts";

export const menuItemClickHandler: DOMEventTelemetryHandler<"click"> = {
    isHandling: evt => {
        return !isNil(evt.target) && actsAsMenuItem(evt.target as HTMLElement);
    },
    handleEvent: (evt, onEvent) => {
        const menuItem = evt.target as HTMLElement;

        let text = "";
        try {
            text = getMenuItemName(menuItem) || "Redacted";
        } catch {
            text = getTelemetryName(menuItem) || "Redacted";
        }

        const modalInformation = getModalInformation(menuItem);
        const menu = getMenuTitle(menuItem);

        void onEvent(MixpanelEventName.MenuItemClicked, {
            [MixpanelProperty.Name]: `${menu} - ${text}`,
            [MixpanelProperty.Modal]: modalInformation
        });
    }
};

function actsAsMenuItem(element: HTMLElement) {
    return !!getClosestRole(element, "menuitem");
}

function getMenuTitle(element: HTMLElement) {
    const menu = getClosestRole(element, "menu");

    return getTelemetryName(menu);
}

function getMenuItemName(element: HTMLElement) {
    const item = getClosestRole(element, "menuitem");

    return getTelemetryName(item);
}
